import _JSXStyle from "styled-jsx/style";
import { colors } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
const InputPlaceholder = _ref => {
  let {
    placeholder,
    className,
    dataTest
  } = _ref;
  if (!placeholder) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["1027033961", [colors.grey600]]]) + " " + (className || "")
  }, placeholder, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1027033961",
    dynamic: [colors.grey600]
  }, [`div.__jsx-style-dynamic-selector{color:${colors.grey600};-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}`]));
};
InputPlaceholder.propTypes = {
  dataTest: PropTypes.string.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string
};
export { InputPlaceholder };